export default "__VITE_ASSET__Bk0wO52M__"